export const GET_VIDEOS = 'GET_VIDEOS'
export const GET_VIDEOS_SUCCESS = 'GET_VIDEOS_SUCCESS'
export const GET_VIDEOS_FAILURE = 'GET_VIDEOS_FAILURE'
